export default __webpack_public_path__ + "static/media/gallery_00.3ba92ee2.jpg";